import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/doc.svg'
import _imports_1 from '@/assets/docx.svg'
import _imports_2 from '@/assets/xls.svg'
import _imports_3 from '@/assets/xlsx.svg'
import _imports_4 from '@/assets/pdf.svg'
import _imports_5 from '@/assets/txt.svg'
import _imports_6 from '@/assets/png.svg'
import _imports_7 from '@/assets/jpg.svg'
import _imports_8 from '@/assets/jpeg.svg'
import _imports_9 from '@/assets/csv.svg'
import _imports_10 from '@/assets/zip.svg'
import _imports_11 from '@/assets/mp4.svg'
import _imports_12 from '@/assets/link.svg'
import _imports_13 from '@/assets/deleteIcon.svg'
import _imports_14 from '@/assets/sortBy.svg'
import _imports_15 from '@/assets/arrowRight.svg'
import _imports_16 from '@/assets/cancel.svg'
import _imports_17 from '@/assets/fileUploadIcon.svg'
import _imports_18 from '@/assets/Browse.svg'
import _imports_19 from '@/assets/warning.svg'
import _imports_20 from '@/assets/filter.svg'


const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_4 = { class: "row w-full h-full flex mt-2 justify-between" }
const _hoisted_5 = {
  key: 0,
  class: "truncate min-w-0 max-w-[calc(100%-2.5rem)] pr-4"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "flex flex-row"
}
const _hoisted_8 = {
  key: 3,
  class: "flex flex-row"
}
const _hoisted_9 = { class: "w-full minheight" }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { class: "mainContainer tabStructure flex flex-row w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey" }
const _hoisted_13 = { class: "w-80 heightFixing pr-5" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_16 = {
  key: 1,
  class: "h-full"
}
const _hoisted_17 = {
  key: 0,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_18 = { class: "flex flex-row" }
const _hoisted_19 = { class: "border border-lightgrey w-77 p-2 rounded-tr-md text-xs" }
const _hoisted_20 = { class: "flex flex-row" }
const _hoisted_21 = { class: "border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "flex flex-row" }
const _hoisted_24 = { class: "border header border-lightgrey w-77 p-2 rounded-tr-md text-xs" }
const _hoisted_25 = { class: "w-full flex flex-row" }
const _hoisted_26 = { class: "w-27 border-b border-l border-lightgrey text-xs p-2" }
const _hoisted_27 = { class: "mt-1" }
const _hoisted_28 = { class: "border-r w-27 border-b border-l border-lightgrey p-2" }
const _hoisted_29 = { class: "pl-3 flex items-center flex-wrap" }
const _hoisted_30 = { class: "flex flex-row" }
const _hoisted_31 = { class: "border-r border-b border-l border-lightgrey w-77 text-xs p-2" }
const _hoisted_32 = { class: "flex flex-row" }
const _hoisted_33 = { class: "border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify" }
const _hoisted_34 = { class: "flex flex-row" }
const _hoisted_35 = { class: "border-r border-b border-l border-lightgrey w-77 p-2 text-xs flex items-center" }
const _hoisted_36 = ["title"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "flex flex-row" }
const _hoisted_39 = { class: "border-r border-b border-l border-lightgrey w-77 min-w-0 text-xs p-2 text-justify rounded-br-md" }
const _hoisted_40 = {
  key: 0,
  class: "flex gap-3 flex-wrap"
}
const _hoisted_41 = { class: "pdf w-full rounded-sm" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_44 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_45 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_46 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_47 = {
  key: 4,
  src: _imports_4,
  alt: ""
}
const _hoisted_48 = {
  key: 5,
  src: _imports_5,
  alt: ""
}
const _hoisted_49 = {
  key: 6,
  src: _imports_6,
  alt: ""
}
const _hoisted_50 = {
  key: 7,
  src: _imports_7,
  alt: ""
}
const _hoisted_51 = {
  key: 8,
  src: _imports_8,
  alt: ""
}
const _hoisted_52 = {
  key: 9,
  src: _imports_9,
  alt: ""
}
const _hoisted_53 = {
  key: 10,
  src: _imports_10,
  alt: ""
}
const _hoisted_54 = {
  key: 11,
  src: _imports_11,
  alt: ""
}
const _hoisted_55 = {
  key: 12,
  src: _imports_4,
  alt: ""
}
const _hoisted_56 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_57 = { class: "ml-2 pb-1" }
const _hoisted_58 = ["title"]
const _hoisted_59 = { class: "flex justify-between w-full" }
const _hoisted_60 = { class: "ml-2 fontSize10PX" }
const _hoisted_61 = { class: "mr-2 fontSize10PX font-semibold" }
const _hoisted_62 = { class: "pdf w-full rounded-sm" }
const _hoisted_63 = ["onClick", "aria-label"]
const _hoisted_64 = { class: "finding-evidence-link-icon__img-wrap" }
const _hoisted_65 = { class: "finding-evidence-link-icon__tooltip" }
const _hoisted_66 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_67 = { class: "ml-2 pb-1" }
const _hoisted_68 = ["title"]
const _hoisted_69 = { class: "flex justify-between w-full" }
const _hoisted_70 = { class: "ml-2 fontSize10PX" }
const _hoisted_71 = { class: "mr-2 fontSize10PX font-semibold" }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { class: "w-full flex flex-row" }
const _hoisted_74 = { class: "w-27 border-b border-l border-lightgrey p-2" }
const _hoisted_75 = {
  key: 0,
  class: "flex items-center justify-center rounded w-28 h-5 text-error bg-highColor border-solid border text-xs border-error p-1 font-semibold"
}
const _hoisted_76 = {
  key: 1,
  class: "flex items-center justify-center rounded w-28 h-5 text-darkred bg-veryHighColor border-solid border text-xs border-darkred p-1 font-semibold"
}
const _hoisted_77 = {
  key: 2,
  class: "flex items-center justify-center rounded w-28 h-5 text-lightgreen bg-veryLowColor border-solid border text-xs border-lightgreen p-1 font-semibold"
}
const _hoisted_78 = {
  key: 3,
  class: "flex items-center justify-center rounded w-28 h-5 text-yellow bg-moderateColor border-solid border text-xs border-yellow p-1 font-semibold"
}
const _hoisted_79 = { class: "border-r w-27 border-b border-l border-lightgrey p-2 rounded-br-md" }
const _hoisted_80 = {
  key: 0,
  class: "flex items-center justify-center rounded h-5 w-28 text-lightgreen bg-veryLowColor border-solid text-xs border border-lightgreen font-semibold"
}
const _hoisted_81 = {
  key: 1,
  class: "flex items-center justify-center rounded h-5 w-28 text-darkred bg-veryHighColor border-solid text-xs border border-darkred font-semibold"
}
const _hoisted_82 = {
  key: 1,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_83 = {
  key: 2,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_84 = { class: "evidence-tab-content" }
const _hoisted_85 = { class: "evidence-files-block" }
const _hoisted_86 = { class: "border-b border-lightgrey flex justify-between items-center pb-2 mt-3" }
const _hoisted_87 = { class: "buttonposition flex justify-center items-center gap-2" }
const _hoisted_88 = {
  key: 0,
  class: "flex mt-5 gap-4 flex-wrap"
}
const _hoisted_89 = { class: "pdf w-full rounded-sm" }
const _hoisted_90 = ["onClick"]
const _hoisted_91 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_92 = {
  key: 1,
  src: _imports_4,
  alt: ""
}
const _hoisted_93 = {
  key: 2,
  src: _imports_1,
  alt: ""
}
const _hoisted_94 = {
  key: 3,
  src: _imports_2,
  alt: ""
}
const _hoisted_95 = {
  key: 4,
  src: _imports_3,
  alt: ""
}
const _hoisted_96 = {
  key: 5,
  src: _imports_4,
  alt: ""
}
const _hoisted_97 = {
  key: 6,
  src: _imports_5,
  alt: ""
}
const _hoisted_98 = {
  key: 7,
  src: _imports_6,
  alt: ""
}
const _hoisted_99 = {
  key: 8,
  src: _imports_7,
  alt: ""
}
const _hoisted_100 = {
  key: 9,
  src: _imports_8,
  alt: ""
}
const _hoisted_101 = {
  key: 10,
  src: _imports_9,
  alt: ""
}
const _hoisted_102 = {
  key: 11,
  src: _imports_10,
  alt: ""
}
const _hoisted_103 = {
  key: 12,
  src: _imports_11,
  alt: ""
}
const _hoisted_104 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_105 = { class: "ml-2 pb-1" }
const _hoisted_106 = ["title"]
const _hoisted_107 = { class: "flex justify-between w-full" }
const _hoisted_108 = { class: "ml-2 fontSize10PX" }
const _hoisted_109 = { class: "mr-2 fontSize10PX font-semibold" }
const _hoisted_110 = ["onClick"]
const _hoisted_111 = {
  key: 1,
  class: "text-xs text-placeholdergray mt-3"
}
const _hoisted_112 = { class: "evidence-links-section" }
const _hoisted_113 = { class: "border-b border-lightgrey flex justify-between items-center pb-2 mt-6" }
const _hoisted_114 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_115 = { class: "evidence-links-scroll" }
const _hoisted_116 = { class: "evidence-links-header" }
const _hoisted_117 = { class: "flex items-center" }
const _hoisted_118 = { class: "flex items-center" }
const _hoisted_119 = { class: "flex items-center" }
const _hoisted_120 = { class: "flex items-center" }
const _hoisted_121 = { class: "evidence-links-body" }
const _hoisted_122 = { key: 0 }
const _hoisted_123 = ["title"]
const _hoisted_124 = { class: "table-ellipsis" }
const _hoisted_125 = ["title"]
const _hoisted_126 = { class: "table-ellipsis" }
const _hoisted_127 = { class: "evidence-links-col-link" }
const _hoisted_128 = { class: "table-ellipsis" }
const _hoisted_129 = ["onClick", "title"]
const _hoisted_130 = { class: "evidence-links-col-date" }
const _hoisted_131 = { class: "evidence-links-col-action" }
const _hoisted_132 = ["onClick"]
const _hoisted_133 = { key: 1 }
const _hoisted_134 = {
  key: 3,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_135 = { class: "border-b border-lightgrey flex justify-between pb-2 mt-3" }
const _hoisted_136 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_137 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_138 = { class: "comment-box w-full mt-5" }
const _hoisted_139 = {
  key: 0,
  class: "comments"
}
const _hoisted_140 = { class: "initials" }
const _hoisted_141 = { class: "w-20" }
const _hoisted_142 = { class: "header" }
const _hoisted_143 = { class: "fontSize10PX" }
const _hoisted_144 = { class: "w-80 headerText" }
const _hoisted_145 = {
  key: 4,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_146 = { class: "border-b border-lightgrey flex justify-between pb-2 mt-3" }
const _hoisted_147 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_148 = {
  key: 0,
  class: "initials"
}
const _hoisted_149 = {
  key: 1,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_150 = {
  key: 2,
  class: "initials"
}
const _hoisted_151 = {
  key: 3,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_152 = {
  key: 4,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_153 = {
  key: 5,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_154 = {
  key: 6,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_155 = {
  key: 7,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_156 = {
  key: 8,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_157 = {
  key: 5,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_158 = { class: "border-b border-lightgrey flex justify-between pb-2 mt-3" }
const _hoisted_159 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_160 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_161 = { class: "flex" }
const _hoisted_162 = {
  key: 0,
  class: "initials"
}
const _hoisted_163 = {
  key: 1,
  class: "initials"
}
const _hoisted_164 = { class: "logContainer w-93" }
const _hoisted_165 = { class: "flex mt-1" }
const _hoisted_166 = {
  key: 0,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_167 = {
  key: 1,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_168 = {
  key: 2,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_169 = {
  key: 3,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_170 = {
  key: 4,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_171 = {
  key: 5,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_172 = {
  key: 6,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_173 = {
  key: 7,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_174 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_175 = { key: 0 }
const _hoisted_176 = {
  key: 0,
  class: "flex"
}
const _hoisted_177 = { class: "text-xs w-full" }
const _hoisted_178 = {
  key: 1,
  class: "flex"
}
const _hoisted_179 = { class: "mx-2 text-xs" }
const _hoisted_180 = {
  key: 2,
  class: "flex"
}
const _hoisted_181 = { class: "mx-2 text-xs" }
const _hoisted_182 = {
  key: 3,
  class: "flex"
}
const _hoisted_183 = { class: "mx-2 text-xs" }
const _hoisted_184 = {
  key: 4,
  class: "flex mt-2"
}
const _hoisted_185 = { class: "mx-2 text-xs" }
const _hoisted_186 = {
  key: 5,
  class: "flex mt-2"
}
const _hoisted_187 = { class: "mx-2 text-xs" }
const _hoisted_188 = {
  key: 6,
  class: "flex mt-2"
}
const _hoisted_189 = { class: "mx-2 text-xs" }
const _hoisted_190 = { class: "mx-2 text-xs" }
const _hoisted_191 = {
  key: 7,
  class: "flex"
}
const _hoisted_192 = { class: "mx-2 text-xs" }
const _hoisted_193 = {
  key: 8,
  class: "flex"
}
const _hoisted_194 = { key: 0 }
const _hoisted_195 = { key: 1 }
const _hoisted_196 = {
  key: 2,
  class: "flex"
}
const _hoisted_197 = { class: "mx-2 text-xs text-justify" }
const _hoisted_198 = {
  key: 9,
  class: "flex items-center"
}
const _hoisted_199 = { class: "flex ml-4" }
const _hoisted_200 = { class: "w-20 border taskDetailsRightBar rounded-sm border-lightgrey" }
const _hoisted_201 = { class: "m-3" }
const _hoisted_202 = { key: 0 }
const _hoisted_203 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_204 = {
  key: 1,
  class: "pt-1.5 overflow-y-scroll thirtyWidthToggle"
}
const _hoisted_205 = { class: "flex flex-col" }
const _hoisted_206 = {
  key: 0,
  class: "bg-error textColorWhite inputboxstyling1 cursor-pointer mt-2"
}
const _hoisted_207 = {
  key: 1,
  disabled: "",
  type: "text",
  placeholder: "Status",
  class: "completedBox inputboxstyling mt-2",
  value: "Completed"
}
const _hoisted_208 = ["disabled"]
const _hoisted_209 = { class: "mt-2" }
const _hoisted_210 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_211 = { key: 1 }
const _hoisted_212 = { class: "mt-3" }
const _hoisted_213 = ["disabled"]
const _hoisted_214 = { class: "mt-3" }
const _hoisted_215 = {
  key: 0,
  class: "my-1 mt-2 text-sm"
}
const _hoisted_216 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_217 = { class: "mt-3" }
const _hoisted_218 = {
  key: 0,
  class: "my-1 text-sm"
}
const _hoisted_219 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_220 = { class: "mt-3" }
const _hoisted_221 = {
  key: 0,
  class: "my-1 text-sm"
}
const _hoisted_222 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_223 = { class: "mt-3" }
const _hoisted_224 = {
  key: 0,
  class: "my-1 text-sm"
}
const _hoisted_225 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex" }
const _hoisted_226 = { class: "relative w-full max-w-xl" }
const _hoisted_227 = { class: "border-0 rounded relative flex flex-col w-full bg-white h-screen" }
const _hoisted_228 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_229 = { class: "flex-1 overflow-auto" }
const _hoisted_230 = { class: "impactcontainer popupbodycontainer" }
const _hoisted_231 = { class: "formcontainer flex flex-col" }
const _hoisted_232 = { class: "row flex flex-col mt-2" }
const _hoisted_233 = { class: "controllabel" }
const _hoisted_234 = ["placeholder"]
const _hoisted_235 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_236 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_237 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_238 = {
  key: 0,
  class: "pt-3"
}
const _hoisted_239 = {
  key: 0,
  class: "text-sm font-semibold text-darkblue mb-4"
}
const _hoisted_240 = {
  key: 1,
  class: "text-sm font-semibold text-primary mb-4"
}
const _hoisted_241 = { class: "flex items-center justify-center gap-2" }
const _hoisted_242 = ["disabled"]
const _hoisted_243 = { class: "min-h-[22px] text-red-500" }
const _hoisted_244 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_245 = {
  key: 1,
  class: "text-red-500 text-xs"
}
const _hoisted_246 = {
  key: 1,
  class: "pt-3"
}
const _hoisted_247 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_248 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_249 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_250 = { class: "pt-3 w-1/2" }
const _hoisted_251 = ["max"]
const _hoisted_252 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_253 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_254 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_255 = ["disabled"]
const _hoisted_256 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex" }
const _hoisted_257 = { class: "relative w-full max-w-xl" }
const _hoisted_258 = { class: "border-0 rounded relative flex flex-col w-full bg-white h-screen" }
const _hoisted_259 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_260 = { class: "flex flex-col h-full" }
const _hoisted_261 = { class: "flex-1 overflow-auto" }
const _hoisted_262 = { class: "statuscontainer px-5 pb-5 h-full" }
const _hoisted_263 = { class: "formcontainer flex flex-col" }
const _hoisted_264 = { class: "row flex flex-row mt-3" }
const _hoisted_265 = { class: "w-1/2" }
const _hoisted_266 = { class: "row flex flex-row mt-3" }
const _hoisted_267 = { class: "w-full" }
const _hoisted_268 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_269 = ["disabled"]
const _hoisted_270 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_271 = { class: "flex flex-col h-full" }
const _hoisted_272 = { class: "flex-1 overflow-auto" }
const _hoisted_273 = { class: "statuscontainer px-5 py-5" }
const _hoisted_274 = { class: "formcontainer flex flex-col w-full" }
const _hoisted_275 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_276 = ["disabled"]
const _hoisted_277 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_278 = { class: "popup-business" }
const _hoisted_279 = { class: "statuscontainer px-4 py-4" }
const _hoisted_280 = { class: "formcontainer flex flex-col w-full" }
const _hoisted_281 = { class: "buttonposition flex justify-center items-center mb-4 mx-0" }
const _hoisted_282 = ["disabled"]
const _hoisted_283 = {
  key: 0,
  class: "evidence-delete-confirm"
}
const _hoisted_284 = { class: "evidence-delete-dialog" }
const _hoisted_285 = { class: "evidence-delete-dialog-actions" }
const _hoisted_286 = {
  key: 1,
  class: "link-existing-confirm"
}
const _hoisted_287 = { class: "link-existing-dialog" }
const _hoisted_288 = { class: "link-existing-tables" }
const _hoisted_289 = { class: "link-existing-section-row" }
const _hoisted_290 = { class: "link-existing-section" }
const _hoisted_291 = { class: "link-existing-table" }
const _hoisted_292 = { class: "flex table-header-label-wrap" }
const _hoisted_293 = { class: "flex table-header-label-wrap" }
const _hoisted_294 = { class: "flex table-header-label-wrap" }
const _hoisted_295 = { class: "flex table-header-label-wrap" }
const _hoisted_296 = {
  key: 0,
  class: "link-existing-filter-row"
}
const _hoisted_297 = { key: 0 }
const _hoisted_298 = { class: "link-existing-col-check" }
const _hoisted_299 = ["checked", "onChange"]
const _hoisted_300 = ["title"]
const _hoisted_301 = { key: 1 }
const _hoisted_302 = { class: "link-existing-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_commentsEditor = _resolveComponent("commentsEditor")!
  const _component_safeHtml = _resolveComponent("safeHtml")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_ctx.dotsLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_dots_loader)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.modalMode ? 'details-in-modal task-details-in-modal' : 'mb-5 mx-5 mt-3 ResponsiveControlePage')
        }, [
          (!_ctx.modalMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.modalMode)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.presentFindingTaskObj.action != undefined ? _ctx.presentFindingTaskObj.action : 'N/A'), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_6)),
            ((_ctx.presentFindingTaskObj.auditor == _ctx.userInfo._id || _ctx.userInfo?.role_id!=10216) && (_ctx.presentFindingTaskObj.statusCode == 10421))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btnprimary items-center mr-2",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.approveOrRejectForActionTasktoComplete(10403,7)))
                  }, "Approve"),
                  _createElementVNode("button", {
                    class: "btnprimary items-center",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickToRejectByJustification()))
                  }, "Reject")
                ]))
              : _createCommentVNode("", true),
            (_ctx.presentFindingTaskObj.approvals && _ctx.presentFindingTaskObj.approvals.length && _ctx.presentFindingTaskObj.approvals[_ctx.presentFindingTaskObj.approvals.length - 1].statusCode== 10401 && _ctx.presentFindingTaskObj.approvals[_ctx.presentFindingTaskObj.approvals.length - 1].approver == _ctx.userInfo._id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "btnprimary items-center mr-2",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ApprovalforInprogress(10403)))
                  }, "Approve"),
                  _createElementVNode("button", {
                    class: "btnprimary items-center",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClickToRejectByJustificationAtInReview()))
                  }, "Reject")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_Tabs, {
                      value: _ctx.selectedTabIndex,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
                      scrollable: "",
                      class: "heightFixing"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_TabList, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                                return (_openBlock(), _createBlock(_component_Tab, {
                                  key: tab.id,
                                  value: tab.id,
                                  onClick: ($event: any) => (_ctx.toggleTabs(tab))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tab.displayName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                              return (_openBlock(), _createBlock(_component_TabPanel, {
                                key: tab.id,
                                value: tab.id
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.tabDataLoading == true)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, [
                                          _createVNode(_component_dots_loader)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        (tab.id == 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                              _createElementVNode("div", null, [
                                                _cache[85] || (_cache[85] = _createElementVNode("div", null, [
                                                  _createElementVNode("div", { class: "border-b border-lightgrey flex justify-between mb-3 paddingBottomForFindings" }, [
                                                    _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                      _createElementVNode("div", null, [
                                                        _createElementVNode("p", { class: "header mt-2.5" }, "Action Information")
                                                      ])
                                                    ])
                                                  ])
                                                ], -1)),
                                                _createElementVNode("div", _hoisted_18, [
                                                  _cache[72] || (_cache[72] = _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md" }, " Cause ", -1)),
                                                  _createElementVNode("div", _hoisted_19, _toDisplayString((_ctx.presentFindingTaskObj.cause != undefined ? _ctx.presentFindingTaskObj.cause : 'N/A')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_20, [
                                                  _cache[73] || (_cache[73] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, " Action ", -1)),
                                                  _createElementVNode("div", _hoisted_21, _toDisplayString((_ctx.presentFindingTaskObj.action != undefined ? _ctx.presentFindingTaskObj.action : 'N/A')), 1)
                                                ]),
                                                _cache[86] || (_cache[86] = _createElementVNode("div", null, [
                                                  _createElementVNode("div", { class: "border-b border-lightgrey flex justify-between mb-5 paddingBottomForFindings mt-3" }, [
                                                    _createElementVNode("div", { class: "marginBottom1px flex items-center justify-center" }, [
                                                      _createElementVNode("div", null, [
                                                        _createElementVNode("p", { class: "header mt-0.5" }, "Finding Information")
                                                      ])
                                                    ])
                                                  ])
                                                ], -1)),
                                                (_ctx.presentFindingObject[0])
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                      _createElementVNode("div", _hoisted_23, [
                                                        _cache[74] || (_cache[74] = _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md" }, "Finding ID", -1)),
                                                        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.presentFindingObject[0].findingId), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_25, [
                                                        _cache[75] || (_cache[75] = _createElementVNode("div", { class: "border-l w-23 border-b p-2 header border-lightgrey" }, "Framework", -1)),
                                                        _createElementVNode("div", _hoisted_26, [
                                                          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.presentFindingObject[0].frameworks), 1)
                                                        ]),
                                                        _cache[76] || (_cache[76] = _createElementVNode("div", { class: "border-l w-23 border-b p-2 header border-lightgrey" }, "Control Number", -1)),
                                                        _createElementVNode("div", _hoisted_28, [
                                                          _createElementVNode("div", _hoisted_29, [
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass([_ctx.getBorder(), "text-xs px-2 py-0.5 font-opensans bg-white font-bold h-auto w-fit flex items-center"])
                                                            }, _toDisplayString(_ctx.presentFindingObject[0].frameWorkControl), 3)
                                                          ])
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_30, [
                                                        _cache[77] || (_cache[77] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Control Title", -1)),
                                                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.presentFindingObject[0].frameworkControlTitle ? _ctx.presentFindingObject[0].frameworkControlTitle : 'N/A'), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_32, [
                                                        _cache[78] || (_cache[78] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Finding", -1)),
                                                        _cache[79] || (_cache[79] = _createTextVNode()),
                                                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.presentFindingObject[0].findingComment), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_34, [
                                                        _cache[80] || (_cache[80] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, "Finding Severity", -1)),
                                                        _createElementVNode("div", _hoisted_35, [
                                                          (_ctx.getFindingSeverityValue(_ctx.presentFindingObject[0]) != null)
                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                key: 0,
                                                                class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular whitespace-nowrap overflow-hidden", _ctx.findingSeverityChipBg(_ctx.presentFindingObject[0])]),
                                                                title: _ctx.getFindingSeverityLabel(_ctx.presentFindingObject[0])
                                                              }, [
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["truncate whitespace-nowrap", _ctx.findingSeverityChipText(_ctx.presentFindingObject[0])])
                                                                }, _toDisplayString(_ctx.getFindingSeverityLabel(_ctx.presentFindingObject[0])), 3)
                                                              ], 10, _hoisted_36))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_37, "N/A"))
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_38, [
                                                        _cache[82] || (_cache[82] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey flex items-center" }, " Evidence ", -1)),
                                                        _createElementVNode("div", _hoisted_39, [
                                                          (_ctx.findingFileEvidences.length || _ctx.findingLinkEvidences.length)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.findingFileEvidences, (doc, idx) => {
                                                                  return (_openBlock(), _createElementBlock("div", {
                                                                    key: 'finding-file-'+idx
                                                                  }, [
                                                                    _createElementVNode("div", _hoisted_41, [
                                                                      _createElementVNode("a", {
                                                                        href: "#",
                                                                        onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                                        class: "flex w-full flex-row items-center cursor-pointer"
                                                                      }, [
                                                                        ( _ctx.getEvidenceFileExt(doc)=='doc')
                                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_43))
                                                                          : _createCommentVNode("", true),
                                                                        ( _ctx.getEvidenceFileExt(doc)=='docx')
                                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_44))
                                                                          : _createCommentVNode("", true),
                                                                        ( _ctx.getEvidenceFileExt(doc)=='xls')
                                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_45))
                                                                          : _createCommentVNode("", true),
                                                                        ( _ctx.getEvidenceFileExt(doc)=='xlsx')
                                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_46))
                                                                          : _createCommentVNode("", true),
                                                                        ( _ctx.getEvidenceFileExt(doc)=='rtf')
                                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_47))
                                                                          : _createCommentVNode("", true),
                                                                        ( _ctx.getEvidenceFileExt(doc)=='txt')
                                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_48))
                                                                          : _createCommentVNode("", true),
                                                                        ( _ctx.getEvidenceFileExt(doc)=='png')
                                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_49))
                                                                          : _createCommentVNode("", true),
                                                                        ( _ctx.getEvidenceFileExt(doc)=='jpg')
                                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_50))
                                                                          : _createCommentVNode("", true),
                                                                        ( _ctx.getEvidenceFileExt(doc)=='jpeg')
                                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_51))
                                                                          : _createCommentVNode("", true),
                                                                        ( _ctx.getEvidenceFileExt(doc)=='csv')
                                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_52))
                                                                          : _createCommentVNode("", true),
                                                                        ( _ctx.getEvidenceFileExt(doc)=='zip')
                                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_53))
                                                                          : _createCommentVNode("", true),
                                                                        ( _ctx.getEvidenceFileExt(doc)=='mp4')
                                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_54))
                                                                          : _createCommentVNode("", true),
                                                                        ( _ctx.getEvidenceFileExt(doc)=='pdf')
                                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_55))
                                                                          : _createCommentVNode("", true),
                                                                        _createElementVNode("div", _hoisted_56, [
                                                                          _createElementVNode("div", _hoisted_57, [
                                                                            _createElementVNode("p", {
                                                                              class: "text-xs font-medium truncate",
                                                                              title: doc.filename || doc.name
                                                                            }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_58)
                                                                          ]),
                                                                          _createElementVNode("div", _hoisted_59, [
                                                                            _createElementVNode("p", _hoisted_60, _toDisplayString(doc.evidenceDate?_ctx.formatFileAttachedTime(doc.evidenceDate):'N/A'), 1),
                                                                            _createElementVNode("p", _hoisted_61, _toDisplayString(doc.taskId?doc.taskId:'N/A'), 1)
                                                                          ])
                                                                        ])
                                                                      ], 8, _hoisted_42)
                                                                    ])
                                                                  ]))
                                                                }), 128)),
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.findingLinkEvidences, (doc, idx) => {
                                                                  return (_openBlock(), _createElementBlock("div", {
                                                                    key: 'finding-link-'+idx
                                                                  }, [
                                                                    _createElementVNode("div", _hoisted_62, [
                                                                      _createElementVNode("a", {
                                                                        href: "#",
                                                                        onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                                        class: "flex w-full flex-row items-center cursor-pointer finding-evidence-link-icon",
                                                                        "aria-label": doc.url
                                                                      }, [
                                                                        _createElementVNode("span", _hoisted_64, [
                                                                          _cache[81] || (_cache[81] = _createElementVNode("img", {
                                                                            src: _imports_12,
                                                                            alt: "Link",
                                                                            class: "finding-evidence-link-icon__img"
                                                                          }, null, -1)),
                                                                          _createElementVNode("span", _hoisted_65, _toDisplayString(doc.url), 1)
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_66, [
                                                                          _createElementVNode("div", _hoisted_67, [
                                                                            _createElementVNode("p", {
                                                                              class: "text-xs font-medium truncate",
                                                                              title: doc.filename || doc.name
                                                                            }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_68)
                                                                          ]),
                                                                          _createElementVNode("div", _hoisted_69, [
                                                                            _createElementVNode("p", _hoisted_70, _toDisplayString(doc.evidenceDate?_ctx.formatFileAttachedTime(doc.evidenceDate):'N/A'), 1),
                                                                            _createElementVNode("p", _hoisted_71, _toDisplayString(doc.taskId?doc.taskId:'N/A'), 1)
                                                                          ])
                                                                        ])
                                                                      ], 8, _hoisted_63)
                                                                    ])
                                                                  ]))
                                                                }), 128))
                                                              ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.presentFindingObject[0].findingEvidence), 1))
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_73, [
                                                        _cache[83] || (_cache[83] = _createElementVNode("div", { class: "border-l w-23 border-b p-2 header border-lightgrey rounded-bl-md" }, "Finding Category", -1)),
                                                        _createElementVNode("div", _hoisted_74, [
                                                          (_ctx.presentFindingObject[0].findingCategory === 1)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_75, _toDisplayString(_ctx.getCategory(_ctx.presentFindingObject[0].findingCategory)), 1))
                                                            : _createCommentVNode("", true),
                                                          (_ctx.presentFindingObject[0].findingCategory === 2)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(_ctx.getCategory(_ctx.presentFindingObject[0].findingCategory)), 1))
                                                            : _createCommentVNode("", true),
                                                          (_ctx.presentFindingObject[0].findingCategory === 3)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(_ctx.getCategory(_ctx.presentFindingObject[0].findingCategory)), 1))
                                                            : _createCommentVNode("", true),
                                                          (_ctx.presentFindingObject[0].findingCategory === 4)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(_ctx.getCategory(_ctx.presentFindingObject[0].findingCategory)), 1))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _cache[84] || (_cache[84] = _createElementVNode("div", { class: "border-l w-23 border-b p-2 header border-lightgrey" }, "Control Audit Result", -1)),
                                                        _createElementVNode("div", _hoisted_79, [
                                                          (_ctx.presentFindingObject[0].auditResult === 'Pass')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(_ctx.presentFindingObject[0].auditResult), 1))
                                                            : _createCommentVNode("", true),
                                                          (_ctx.presentFindingObject[0].auditResult === 'Fail')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.presentFindingObject[0].auditResult), 1))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (tab.id == 2)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_82, _cache[87] || (_cache[87] = [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", { class: "border-b border-lightgrey flex justify-between pb-2 mt-3" }, [
                                                  _createElementVNode("div", { class: "flex items-center mt-0.5 marginTopForDoc marginBottomForDoc justify-center" }, [
                                                    _createElementVNode("div", null, [
                                                      _createElementVNode("p", { class: "header" }, "Documents which are related to the controls")
                                                    ])
                                                  ])
                                                ])
                                              ], -1)
                                            ])))
                                          : _createCommentVNode("", true),
                                        (tab.id == 3)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_84, [
                                                  _createElementVNode("div", _hoisted_85, [
                                                    _createElementVNode("div", _hoisted_86, [
                                                      _cache[88] || (_cache[88] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                        _createElementVNode("p", { class: "header" }, "Files")
                                                      ], -1)),
                                                      _createElementVNode("div", _hoisted_87, [
                                                        _createElementVNode("button", {
                                                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openLinkEvidencePopup && _ctx.openLinkEvidencePopup(...args))),
                                                          class: _normalizeClass([_ctx.isEvidenceAttachDisabled() ? 'btndisabled pointer-events-none' : 'filterButton flex justify-center', "flex justify-center"])
                                                        }, "Link Existing", 2),
                                                        _createElementVNode("button", {
                                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openFilePopup('file'))),
                                                          for: "upload",
                                                          class: _normalizeClass([_ctx.TaskDetailsDropDown.taskStatus ==10414 || _ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417 || _ctx.presentAuditObject.statusCode == 10403|| _ctx.presentAuditObject.statusCode == 10418 || _ctx.presentFindingTaskObj.auditor == _ctx.userInfo._id || !_ctx.isAddDisabled(10302)? 'btndisabled pointer-events-none' : 'filterButton flex justify-center', "flex justify-center"])
                                                        }, "Attach", 2)
                                                      ])
                                                    ]),
                                                    (_ctx.fileEvidences.length)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileEvidences, (doc, fileIdx) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                              key: 'capa-file-'+fileIdx
                                                            }, [
                                                              _createElementVNode("div", _hoisted_89, [
                                                                _createElementVNode("a", {
                                                                  href: "#",
                                                                  onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                                  class: "flex w-full flex-row items-center cursor-pointer"
                                                                }, [
                                                                  ( _ctx.getEvidenceFileExt(doc)=='doc')
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_91))
                                                                    : _createCommentVNode("", true),
                                                                  ( _ctx.getEvidenceFileExt(doc)=='pdf')
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_92))
                                                                    : _createCommentVNode("", true),
                                                                  ( _ctx.getEvidenceFileExt(doc)=='docx')
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_93))
                                                                    : _createCommentVNode("", true),
                                                                  ( _ctx.getEvidenceFileExt(doc)=='xls')
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_94))
                                                                    : _createCommentVNode("", true),
                                                                  ( _ctx.getEvidenceFileExt(doc)=='xlsx')
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_95))
                                                                    : _createCommentVNode("", true),
                                                                  ( _ctx.getEvidenceFileExt(doc)=='rtf')
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_96))
                                                                    : _createCommentVNode("", true),
                                                                  ( _ctx.getEvidenceFileExt(doc)=='txt')
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_97))
                                                                    : _createCommentVNode("", true),
                                                                  ( _ctx.getEvidenceFileExt(doc)=='png')
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_98))
                                                                    : _createCommentVNode("", true),
                                                                  ( _ctx.getEvidenceFileExt(doc)=='jpg')
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_99))
                                                                    : _createCommentVNode("", true),
                                                                  ( _ctx.getEvidenceFileExt(doc)=='jpeg')
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_100))
                                                                    : _createCommentVNode("", true),
                                                                  ( _ctx.getEvidenceFileExt(doc)=='csv')
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_101))
                                                                    : _createCommentVNode("", true),
                                                                  ( _ctx.getEvidenceFileExt(doc)=='zip')
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_102))
                                                                    : _createCommentVNode("", true),
                                                                  ( _ctx.getEvidenceFileExt(doc)=='mp4')
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_103))
                                                                    : _createCommentVNode("", true),
                                                                  _createElementVNode("div", _hoisted_104, [
                                                                    _createElementVNode("div", _hoisted_105, [
                                                                      _createElementVNode("p", {
                                                                        class: "text-xs font-medium truncate",
                                                                        title: doc.filename || doc.name
                                                                      }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_106)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_107, [
                                                                      _createElementVNode("p", _hoisted_108, _toDisplayString(doc.evidenceDate?_ctx.formatFileAttachedTime(doc.evidenceDate):'N/A'), 1),
                                                                      _createElementVNode("p", _hoisted_109, _toDisplayString(_ctx.evidenceTaskLabel(doc)), 1)
                                                                    ])
                                                                  ]),
                                                                  (_ctx.canDeleteAuditEvidence(doc))
                                                                    ? (_openBlock(), _createElementBlock("button", {
                                                                        key: 13,
                                                                        type: "button",
                                                                        class: _normalizeClass(["evidence-file-delete", _ctx.isEvidenceAttachDisabled() ? 'pointer-events-none' : '']),
                                                                        onClick: _withModifiers(($event: any) => (_ctx.openDeleteEvidenceConfirm(_ctx.presentFindingTaskObj.files.indexOf(doc))), ["stop","prevent"])
                                                                      }, _cache[89] || (_cache[89] = [
                                                                        _createElementVNode("img", {
                                                                          src: _imports_13,
                                                                          alt: "Delete"
                                                                        }, null, -1)
                                                                      ]), 10, _hoisted_110))
                                                                    : _createCommentVNode("", true)
                                                                ], 8, _hoisted_90)
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("p", _hoisted_111, "No files attached"))
                                                  ]),
                                                  _createElementVNode("div", _hoisted_112, [
                                                    _createElementVNode("div", _hoisted_113, [
                                                      _cache[90] || (_cache[90] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                        _createElementVNode("p", { class: "header" }, "Links")
                                                      ], -1)),
                                                      _createElementVNode("div", _hoisted_114, [
                                                        _createElementVNode("button", {
                                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openFilePopup('url'))),
                                                          class: _normalizeClass([_ctx.TaskDetailsDropDown.taskStatus ==10414 || _ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417 || _ctx.presentAuditObject.statusCode == 10403|| _ctx.presentAuditObject.statusCode == 10418 || _ctx.presentFindingTaskObj.auditor == _ctx.userInfo._id || !_ctx.isAddDisabled(10302)? 'btndisabled pointer-events-none' : 'filterButton flex justify-center', "flex justify-center"])
                                                        }, "Add Link", 2)
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["evidence-links-wrap", { 'evidence-links-wrap--empty': _ctx.filteredLinkCount === 0 }])
                                                    }, [
                                                      _createElementVNode("div", _hoisted_115, [
                                                        _createElementVNode("div", _hoisted_116, [
                                                          _createElementVNode("table", {
                                                            class: "evidence-links-table",
                                                            style: _normalizeStyle(_ctx.linkTableResizeStyle)
                                                          }, [
                                                            _createElementVNode("thead", null, [
                                                              _createElementVNode("tr", null, [
                                                                _createElementVNode("th", {
                                                                  class: "cursor-pointer evidence-links-col-id",
                                                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortLinkEvidences('taskId')))
                                                                }, [
                                                                  _createElementVNode("div", _hoisted_117, [
                                                                    _cache[91] || (_cache[91] = _createElementVNode("div", null, "ID", -1)),
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'taskId' ? _ctx.linkSortClass : 'opacity-50'])
                                                                    }, null, 2)
                                                                  ])
                                                                ]),
                                                                _createElementVNode("th", {
                                                                  class: "cursor-pointer evidence-links-col-title",
                                                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortLinkEvidences('filename')))
                                                                }, [
                                                                  _createElementVNode("div", _hoisted_118, [
                                                                    _cache[92] || (_cache[92] = _createElementVNode("div", null, "Link Title", -1)),
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'filename' ? _ctx.linkSortClass : 'opacity-50'])
                                                                    }, null, 2)
                                                                  ])
                                                                ]),
                                                                _createElementVNode("th", {
                                                                  class: "cursor-pointer evidence-links-col-link",
                                                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortLinkEvidences('url')))
                                                                }, [
                                                                  _createElementVNode("div", _hoisted_119, [
                                                                    _cache[93] || (_cache[93] = _createElementVNode("div", null, "Link", -1)),
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'url' ? _ctx.linkSortClass : 'opacity-50'])
                                                                    }, null, 2)
                                                                  ])
                                                                ]),
                                                                _createElementVNode("th", {
                                                                  class: "cursor-pointer evidence-links-col-date",
                                                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sortLinkEvidences('evidenceDate')))
                                                                }, [
                                                                  _createElementVNode("div", _hoisted_120, [
                                                                    _cache[94] || (_cache[94] = _createElementVNode("div", null, "Evidence Date", -1)),
                                                                    _createElementVNode("div", {
                                                                      class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'evidenceDate' ? _ctx.linkSortClass : 'opacity-50'])
                                                                    }, null, 2)
                                                                  ])
                                                                ]),
                                                                _cache[95] || (_cache[95] = _createElementVNode("th", { class: "evidence-links-col-action" }, null, -1))
                                                              ])
                                                            ])
                                                          ], 4)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_121, [
                                                          _createElementVNode("table", {
                                                            class: "evidence-links-table",
                                                            style: _normalizeStyle(_ctx.linkTableResizeStyle)
                                                          }, [
                                                            (_ctx.paginatedLinkEvidences.length)
                                                              ? (_openBlock(), _createElementBlock("tbody", _hoisted_122, [
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedLinkEvidences, (doc, idx) => {
                                                                    return (_openBlock(), _createElementBlock("tr", {
                                                                      key: 'link-'+idx,
                                                                      class: "rowHeight evidence-links-row"
                                                                    }, [
                                                                      _createElementVNode("td", {
                                                                        class: "evidence-links-col-id",
                                                                        title: _ctx.evidenceTaskLabel(doc)
                                                                      }, [
                                                                        _createElementVNode("div", _hoisted_124, _toDisplayString(_ctx.evidenceTaskLabel(doc)), 1)
                                                                      ], 8, _hoisted_123),
                                                                      _createElementVNode("td", {
                                                                        class: "evidence-links-col-title",
                                                                        title: doc.filename || doc.name
                                                                      }, [
                                                                        _createElementVNode("div", _hoisted_126, _toDisplayString(doc.filename || doc.name || 'N/A'), 1)
                                                                      ], 8, _hoisted_125),
                                                                      _createElementVNode("td", _hoisted_127, [
                                                                        _createElementVNode("div", _hoisted_128, [
                                                                          _createElementVNode("a", {
                                                                            href: "#",
                                                                            class: "text-primary evidence-link-anchor cursor-pointer",
                                                                            onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                                            title: doc.url
                                                                          }, _toDisplayString(doc.url), 9, _hoisted_129)
                                                                        ])
                                                                      ]),
                                                                      _createElementVNode("td", _hoisted_130, _toDisplayString(doc.evidenceDate ? _ctx.formatFileAttachedTime(doc.evidenceDate) : 'N/A'), 1),
                                                                      _createElementVNode("td", _hoisted_131, [
                                                                        (_ctx.canDeleteAuditEvidence(doc))
                                                                          ? (_openBlock(), _createElementBlock("button", {
                                                                              key: 0,
                                                                              type: "button",
                                                                              class: _normalizeClass(["evidence-links-delete", _ctx.isEvidenceAttachDisabled() ? 'pointer-events-none' : '']),
                                                                              onClick: _withModifiers(($event: any) => (_ctx.openDeleteEvidenceConfirm(_ctx.presentFindingTaskObj.files.indexOf(doc))), ["stop","prevent"])
                                                                            }, _cache[96] || (_cache[96] = [
                                                                              _createElementVNode("img", {
                                                                                src: _imports_13,
                                                                                alt: "Delete",
                                                                                class: "h-5 w-5"
                                                                              }, null, -1)
                                                                            ]), 10, _hoisted_132))
                                                                          : _createCommentVNode("", true)
                                                                      ])
                                                                    ]))
                                                                  }), 128))
                                                                ]))
                                                              : (_openBlock(), _createElementBlock("tbody", _hoisted_133, _cache[97] || (_cache[97] = [
                                                                  _createElementVNode("tr", null, [
                                                                    _createElementVNode("td", {
                                                                      class: "evidence-links-empty",
                                                                      colspan: "5"
                                                                    }, [
                                                                      _createElementVNode("div", { class: "flex justify-center" }, [
                                                                        _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                                                                      ])
                                                                    ])
                                                                  ], -1)
                                                                ])))
                                                          ], 4)
                                                        ])
                                                      ]),
                                                      (_ctx.filteredLinkCount > 0)
                                                        ? (_openBlock(), _createBlock(_component_pagination, {
                                                            key: 0,
                                                            dynamicPagination: _ctx.filteredLinkCount,
                                                            sortedData: _ctx.sortedLinkEvidences,
                                                            onCurrentPageUpdate: _ctx.onLinkPaginationUpdate
                                                          }, null, 8, ["dynamicPagination", "sortedData", "onCurrentPageUpdate"]))
                                                        : _createCommentVNode("", true)
                                                    ], 2)
                                                  ])
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (tab.id == 4)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_135, [
                                                  _cache[100] || (_cache[100] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                    _createElementVNode("div", null, [
                                                      _createElementVNode("p", { class: "header" }, "Comments")
                                                    ])
                                                  ], -1)),
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("div", _hoisted_136, [
                                                      _createElementVNode("div", _hoisted_137, [
                                                        (_ctx.oldComments)
                                                          ? (_openBlock(), _createElementBlock("button", {
                                                              key: 0,
                                                              class: "filterButton w-24 flex",
                                                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sortComments()))
                                                            }, _cache[98] || (_cache[98] = [
                                                              _createElementVNode("img", {
                                                                src: _imports_14,
                                                                class: "h-3 mr-2.5"
                                                              }, null, -1),
                                                              _createTextVNode(" Oldest ")
                                                            ])))
                                                          : _createCommentVNode("", true),
                                                        (!_ctx.oldComments)
                                                          ? (_openBlock(), _createElementBlock("button", {
                                                              key: 1,
                                                              class: "filterButton w-24 flex",
                                                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sortComments()))
                                                            }, _cache[99] || (_cache[99] = [
                                                              _createElementVNode("img", {
                                                                src: _imports_14,
                                                                class: "h-3 mr-2.5 rotate-180"
                                                              }, null, -1),
                                                              _createTextVNode(" Newest ")
                                                            ])))
                                                          : _createCommentVNode("", true)
                                                      ])
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("div", _hoisted_138, [
                                                    (_ctx.TaskDetailsDropDown.taskStatus!=10403 && _ctx.TaskDetailsDropDown.taskStatus!=10418 &&_ctx.isAddDisabled(10302))
                                                      ? (_openBlock(), _createBlock(_component_commentsEditor, {
                                                          key: 0,
                                                          taskStatusCode: _ctx.TaskDetailsDropDown.taskStatus
                                                        }, null, 8, ["taskStatusCode"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  (Object.keys(_ctx.presentFindingTaskObj).includes('comments'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentFindingTaskObj.comments, (obj, index) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            class: "border border-lightgrey mt-2 rounded-sm flex flex-row p-3",
                                                            key: index
                                                          }, [
                                                            _createElementVNode("div", _hoisted_140, _toDisplayString(_ctx.extractInitials((obj.name) )), 1),
                                                            _createElementVNode("div", _hoisted_141, [
                                                              _createElementVNode("div", _hoisted_142, _toDisplayString(obj.name), 1),
                                                              _createElementVNode("div", _hoisted_143, _toDisplayString(obj.createdAt), 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_144, [
                                                              _createVNode(_component_safeHtml, {
                                                                content: obj.comment
                                                              }, null, 8, ["content"])
                                                            ])
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (tab.id == 5)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_146, [
                                                  _cache[101] || (_cache[101] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                    _createElementVNode("div", null, [
                                                      _createElementVNode("p", { class: "header" }, "Approvals")
                                                    ])
                                                  ], -1)),
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("div", _hoisted_147, [
                                                      _createElementVNode("button", {
                                                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openApprovalpopup())),
                                                        class: _normalizeClass([_ctx.TaskDetailsDropDown.taskStatus ==10419 || _ctx.approvalObj.statusCode == 10401 || _ctx.presentFindingTaskObj.statusCode == 10403 ||  _ctx.presentFindingTaskObj.auditor == _ctx.userInfo._id||  (_ctx.newTeamAssignee.value != _ctx.userInfo._id  && _ctx.presentFindingTaskObj.auditee != _ctx.userInfo._id || _ctx.userInfo?.role_id!=10217 && _ctx.userInfo.roleId!=10217) || !_ctx.isAddDisabled(10302)?'btndisabled pointer-events-none' : 'filterButton flex justify-center', "flex justify-center"])
                                                      }, "Send Approval", 2)
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentFindingTaskObj.approvals, (approval, number) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: number,
                                                      class: "bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full"
                                                    }, [
                                                      (approval.createdBy != undefined)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_148, _toDisplayString(_ctx.extractInitials(approval.name)), 1))
                                                        : _createCommentVNode("", true),
                                                      (approval.createdBy != undefined)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_149, _toDisplayString(approval.name), 1))
                                                        : _createCommentVNode("", true),
                                                      (approval.updatedBy != undefined)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_150, _toDisplayString(_ctx.extractInitials(approval.name)), 1))
                                                        : _createCommentVNode("", true),
                                                      (approval.updatedBy != undefined)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_151, _toDisplayString(approval.name), 1))
                                                        : _createCommentVNode("", true),
                                                      (approval.statusCode == 10401)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_152, _toDisplayString(' Requested an approval ')))
                                                        : _createCommentVNode("", true),
                                                      (approval.statusCode == 10410)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_153, _toDisplayString(' Rejected an approval ')))
                                                        : (approval.statusCode == 10403)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_154, _toDisplayString(' Approved an approval ')))
                                                          : _createCommentVNode("", true),
                                                      (approval.createdAt != undefined)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_155, _toDisplayString(approval.createdAt), 1))
                                                        : _createCommentVNode("", true),
                                                      (approval.updatedAt != undefined)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_156, _toDisplayString(approval.updatedAt), 1))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  }), 128))
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (tab.id == 6)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_158, [
                                                  _cache[104] || (_cache[104] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                    _createElementVNode("div", null, [
                                                      _createElementVNode("p", { class: "header" }, "History")
                                                    ])
                                                  ], -1)),
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("div", _hoisted_159, [
                                                      _createElementVNode("div", _hoisted_160, [
                                                        (_ctx.newHistory)
                                                          ? (_openBlock(), _createElementBlock("button", {
                                                              key: 0,
                                                              class: "filterButton w-24 flex",
                                                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sortWorkLog()))
                                                            }, _cache[102] || (_cache[102] = [
                                                              _createElementVNode("img", {
                                                                src: _imports_14,
                                                                class: "h-3 mr-2.5"
                                                              }, null, -1),
                                                              _createTextVNode(" Oldest ")
                                                            ])))
                                                          : _createCommentVNode("", true),
                                                        (!_ctx.newHistory)
                                                          ? (_openBlock(), _createElementBlock("button", {
                                                              key: 1,
                                                              class: "filterButton w-24 flex",
                                                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sortWorkLog()))
                                                            }, _cache[103] || (_cache[103] = [
                                                              _createElementVNode("img", {
                                                                src: _imports_14,
                                                                class: "h-3 mr-2.5 rotate-180"
                                                              }, null, -1),
                                                              _createTextVNode(" Newest ")
                                                            ])))
                                                          : _createCommentVNode("", true)
                                                      ])
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLogObject.taskHistory, (work) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: work,
                                                      class: "bg-white p-4 px-0 mb-0.5 border-lightgrey border-b w-full"
                                                    }, [
                                                      _createElementVNode("div", _hoisted_161, [
                                                        (_ctx.checkKey(work,'createdBy'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_162, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work).includes('updatedBy'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_163, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                          : _createCommentVNode("", true),
                                                        _createElementVNode("div", _hoisted_164, [
                                                          _createElementVNode("div", _hoisted_165, [
                                                            (Object.keys(work).includes('createdBy'))
                                                              ? (_openBlock(), _createElementBlock("p", _hoisted_166, _toDisplayString(work.name), 1))
                                                              : (Object.keys(work).includes('updatedBy'))
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_167, _toDisplayString(work.name), 1))
                                                                : _createCommentVNode("", true),
                                                            (work.actionEntity == 10301)
                                                              ? (_openBlock(), _createElementBlock("p", _hoisted_168, _toDisplayString('Created the Task on')))
                                                              : (work.statusCode != undefined && work.statusCode == 10418)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_169, _toDisplayString('Terminated the Task on')))
                                                                : (work.actionEntity == 10302&& !Object.keys(work.additionalInfo).includes('previousDueDate'))
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_170, _toDisplayString('Updated the Task on')))
                                                                  : (work.actionEntity == 10302 && Object.keys(work.additionalInfo).includes('previousDueDate'))
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_171, _toDisplayString('Updated the Due Date at')))
                                                                    : _createCommentVNode("", true),
                                                            (Object.keys(work).includes('createdAt'))
                                                              ? (_openBlock(), _createElementBlock("p", _hoisted_172, _toDisplayString(_ctx.formatTime(work.createdAt)), 1))
                                                              : _createCommentVNode("", true),
                                                            (Object.keys(work).includes('updatedAt'))
                                                              ? (_openBlock(), _createElementBlock("p", _hoisted_173, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          (Object.keys(work).includes('additionalInfo'))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                                                (work.additionalInfo)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                                                                      (_ctx.checkKey(work.additionalInfo,'comment'))
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                                                                            _cache[105] || (_cache[105] = _createElementVNode("div", { class: "font-semibold text-xs widthForCommentBox" }, "Comment :", -1)),
                                                                            _createElementVNode("div", _hoisted_177, [
                                                                              _createVNode(_component_safeHtml, {
                                                                                content: work.additionalInfo.comment
                                                                              }, null, 8, ["content"])
                                                                            ])
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (Object.keys(work.additionalInfo).includes('evidence') && !work.additionalInfo.removed)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                                                                            _cache[106] || (_cache[106] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Uploaded the Evidence -'), -1)),
                                                                            _createElementVNode("p", _hoisted_179, _toDisplayString(work.additionalInfo.evidence), 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (work.additionalInfo.removed)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                                                                            _cache[107] || (_cache[107] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Deleted the Evidence -'), -1)),
                                                                            _createElementVNode("p", _hoisted_181, _toDisplayString(work.additionalInfo.evidence), 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (Object.keys(work.additionalInfo).includes('linkedEvidenceTitles'))
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                                                                            _cache[108] || (_cache[108] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Linked the Evidence -'), -1)),
                                                                            _createElementVNode("p", _hoisted_183, _toDisplayString(work.additionalInfo.linkedEvidenceTitles), 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (Object.keys(work.additionalInfo).includes('linkedEvidenceDates'))
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                                                            _cache[109] || (_cache[109] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Linked Evidence Date -'), -1)),
                                                                            _createElementVNode("p", _hoisted_185, _toDisplayString(work.additionalInfo.linkedEvidenceDates), 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (Object.keys(work.additionalInfo).includes('evidenceDate'))
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                                                                            _cache[110] || (_cache[110] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Evidence Date -'), -1)),
                                                                            _createElementVNode("p", _hoisted_187, _toDisplayString(_ctx.formatDate(work.additionalInfo.evidenceDate)||'N/A'), 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (Object.keys(work.additionalInfo).includes('previousDueDate'))
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_188, [
                                                                            _cache[111] || (_cache[111] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('from '), -1)),
                                                                            _createElementVNode("p", _hoisted_189, _toDisplayString(_ctx.formatDate(work.additionalInfo.previousDueDate)||'N/A'), 1),
                                                                            _cache[112] || (_cache[112] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('to'), -1)),
                                                                            _createElementVNode("p", _hoisted_190, _toDisplayString(_ctx.formatDate(work.additionalInfo.updatedDueDate)||'N/A'), 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (Object.keys(work.additionalInfo).includes('assignee'))
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                                                                            _cache[113] || (_cache[113] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Assigned the Task To -'), -1)),
                                                                            _createElementVNode("p", _hoisted_192, _toDisplayString(_ctx.getPersonName(work.additionalInfo.assignee)), 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (Object.keys(work.additionalInfo).includes('approver'))
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                                                                            (work.additionalInfo.action == 10301)
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_194, _cache[114] || (_cache[114] = [
                                                                                  _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Sent Approval for -'), -1)
                                                                                ])))
                                                                              : _createCommentVNode("", true),
                                                                            (work.additionalInfo.action == 10302 && work.additionalInfo.statusCode == 10403)
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_195, _cache[115] || (_cache[115] = [
                                                                                  _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Approved Approval -'), -1)
                                                                                ])))
                                                                              : _createCommentVNode("", true),
                                                                            (work.additionalInfo.action == 10302 && work.additionalInfo.statusCode == 10410)
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_196, _cache[116] || (_cache[116] = [
                                                                                  _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Rejected Approval -'), -1)
                                                                                ])))
                                                                              : _createCommentVNode("", true),
                                                                            _createElementVNode("p", _hoisted_197, _toDisplayString(_ctx.getPersonName(work.additionalInfo.approver)), 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (Object.keys(work.additionalInfo).includes('previousStatus'))
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                                                                            _cache[118] || (_cache[118] = _createElementVNode("div", null, [
                                                                              _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Updated the status :'))
                                                                            ], -1)),
                                                                            _createElementVNode("div", _hoisted_199, [
                                                                              _createElementVNode("div", {
                                                                                class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorFindingBg(work.additionalInfo.previousStatus)])
                                                                              }, [
                                                                                _createElementVNode("div", {
                                                                                  class: _normalizeClass(_ctx.colorFindingText(work.additionalInfo.previousStatus))
                                                                                }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.previousStatus)), 3)
                                                                              ], 2),
                                                                              _cache[117] || (_cache[117] = _createElementVNode("div", { class: "mx-4 flex items-center" }, [
                                                                                _createElementVNode("img", { src: _imports_15 })
                                                                              ], -1)),
                                                                              _createElementVNode("div", {
                                                                                class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorFindingBg(work.additionalInfo.updatedStatus)])
                                                                              }, [
                                                                                _createElementVNode("div", {
                                                                                  class: _normalizeClass(_ctx.colorFindingText(work.additionalInfo.updatedStatus))
                                                                                }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.updatedStatus)), 3)
                                                                              ], 2)
                                                                            ])
                                                                          ]))
                                                                        : _createCommentVNode("", true)
                                                                    ]))
                                                                  : _createCommentVNode("", true)
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ])
                                                    ]))
                                                  }), 128))
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_200, [
                    _createElementVNode("div", _hoisted_201, [
                      _cache[132] || (_cache[132] = _createElementVNode("div", { class: "pb-2 border-b border-lightgrey" }, [
                        _createElementVNode("h1", null, "Task Details")
                      ], -1)),
                      (_ctx.tabDataLoading == true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                            _createElementVNode("div", _hoisted_203, [
                              _createVNode(_component_dots_loader)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_204, [
                            _createElementVNode("div", _hoisted_205, [
                              _cache[120] || (_cache[120] = _createElementVNode("label", { class: "controllabel" }, "Task Status", -1)),
                              _createElementVNode("div", null, [
                                (_ctx.TaskDetailsDropDown.taskStatus == 10418)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_206, _cache[119] || (_cache[119] = [
                                      _createElementVNode("div", { class: "bg-error textColorWhite" }, _toDisplayString('Terminated'), -1)
                                    ])))
                                  : (_ctx.TaskDetailsDropDown.taskStatus == 10403)
                                    ? (_openBlock(), _createElementBlock("input", _hoisted_207))
                                    : _createCommentVNode("", true),
                                ((_ctx.checkAuditor(_ctx.presentFindingTaskObj.auditor)) && (_ctx.TaskDetailsDropDown.taskStatus == 10414 || _ctx.TaskDetailsDropDown.taskStatus == 10421))
                                  ? (_openBlock(), _createBlock(_component_Select, {
                                      key: 2,
                                      appendTo: "body",
                                      modelValue: _ctx.TaskDetailsDropDown.taskStatus,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.TaskDetailsDropDown.taskStatus) = $event)),
                                      options: _ctx.auditorTaskData,
                                      optionLabel: "value",
                                      optionValue: "id",
                                      placeholder: "Please select one",
                                      class: _normalizeClass(["custom-select w-full mt-2 mb-3 px-2.5 py-1 text-sm font-light text-gray rounded-sm border border-lightgrey selectIcon", _ctx.changeBackground()]),
                                      onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus))),
                                      optionDisabled: _ctx.isOptionDisabled
                                    }, null, 8, ["modelValue", "options", "class", "optionDisabled"]))
                                  : (!(_ctx.checkAuditor(_ctx.presentFindingTaskObj.auditor)) && (_ctx.TaskDetailsDropDown.taskStatus == 10401 || _ctx.TaskDetailsDropDown.taskStatus == 10402 || _ctx.TaskDetailsDropDown.taskStatus == 10408 || _ctx.TaskDetailsDropDown.taskStatus == 10414))
                                    ? (_openBlock(), _createBlock(_component_Select, {
                                        key: 3,
                                        appendTo: "body",
                                        modelValue: _ctx.TaskDetailsDropDown.taskStatus,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.TaskDetailsDropDown.taskStatus) = $event)),
                                        options: _ctx.taskStatusData,
                                        optionLabel: "value",
                                        optionValue: "id",
                                        placeholder: "Please select one",
                                        class: _normalizeClass(["custom-select w-full mt-2 mb-3 px-2.5 py-1 text-sm font-light text-gray rounded-sm border border-lightgrey", _ctx.changeBackground()]),
                                        disabled: _ctx.TaskDetailsDropDown.taskStatus == 10414 ||  _ctx.TaskDetailsDropDown.taskStatus == 10421 ||  _ctx.TaskDetailsDropDown.taskStatus == 10403 ,
                                        onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus))),
                                        optionDisabled: _ctx.isOptionDisabled
                                      }, null, 8, ["modelValue", "options", "class", "disabled", "optionDisabled"]))
                                    : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", null, [
                                (!(_ctx.checkAuditor(_ctx.presentFindingTaskObj.auditor)) && (_ctx.presentFindingTaskObj.statusCode == 10421 ))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass([_ctx.changeBackground(), "inputboxstyling1 disabled cursor-pointer mt-2"])
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(_ctx.changeBackground()),
                                        onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus)))
                                      }, _toDisplayString(_ctx.auditorTaskData.find((data)=>{
																return data.id == _ctx.presentFindingTaskObj.statusCode
															}).value), 35)
                                    ], 2))
                                  : _createCommentVNode("", true),
                                ((_ctx.checkAuditor(_ctx.presentFindingTaskObj.auditor)) && (_ctx.TaskDetailsDropDown.taskStatus == 10401 || _ctx.TaskDetailsDropDown.taskStatus == 10402 || _ctx.TaskDetailsDropDown.taskStatus == 10408))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: _normalizeClass([_ctx.changeBackground(), "inputboxstyling1 disabled cursor-pointer mt-2"]),
                                      disabled: !_ctx.isAddDisabled(10302)
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(_ctx.changeBackground()),
                                        onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus)))
                                      }, _toDisplayString(_ctx.taskStatusData.find((data)=>{
																return data.id == _ctx.presentFindingTaskObj.statusCode
															}).value), 35)
                                    ], 10, _hoisted_208))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_209, [
                                _cache[121] || (_cache[121] = _createElementVNode("label", { class: "controllabel" }, "Assigned To", -1)),
                                (_ctx.TaskDetailsDropDown.taskStatus ==10414 || _ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.TaskDetailsDropDown.taskStatus == 10417 || _ctx.presentFindingTaskObj.statusCode == 10403|| _ctx.presentFindingTaskObj.statusCode == 10418 || (_ctx.newTeamAssignee.value != _ctx.userInfo._id  && _ctx.presentFindingTaskObj.auditee == _ctx.userInfo._id))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_210, _toDisplayString(_ctx.presentFindingTaskObj.assignee != undefined ? _ctx.presentFindingTaskObj.assignee.label : 'N/A'), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_211, [
                                      _createVNode(_component_AutoComplete, {
                                        appendTo: "body",
                                        modelValue: _ctx.presentFindingTaskObj.assignee,
                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.presentFindingTaskObj.assignee) = $event)),
                                        suggestions: _ctx.userOptions,
                                        placeholder: "Assigned-To",
                                        optionLabel: "label",
                                        field: "label",
                                        class: "w-full custom-autocomplete userSelect mt-2",
                                        onComplete: _ctx.asyncFind,
                                        disabled: !_ctx.isAddDisabled(10302),
                                        onItemSelect: _cache[24] || (_cache[24] = ($event: any) => (_ctx.updateAssignedMember(_ctx.presentFindingTaskObj.assignee)))
                                      }, null, 8, ["modelValue", "suggestions", "onComplete", "disabled"])
                                    ]))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_212, [
                              _cache[122] || (_cache[122] = _createElementVNode("label", { class: "controllabel" }, "Due Date", -1)),
                              _cache[123] || (_cache[123] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("div", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "date",
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.presentFindingTaskObj.dueDate) = $event)),
                                  class: "mt-2 w-full stylingForInputboxstylingForSelectAtPopup",
                                  onFocus: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                                  onkeydown: "return false",
                                  placeholder: "Select Date",
                                  disabled: _ctx.TaskDetailsDropDown.taskStatus ==10403||_ctx.TaskDetailsDropDown.taskStatus ==10418,
                                  onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.updateTaskDueDate(7,_ctx.presentFindingTaskObj.dueDate)))
                                }, null, 40, _hoisted_213), [
                                  [_vModelText, _ctx.presentFindingTaskObj.dueDate]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_214, [
                              _cache[124] || (_cache[124] = _createElementVNode("label", { class: "controllabel" }, "Auditor", -1)),
                              _cache[125] || (_cache[125] = _createElementVNode("br", null, null, -1)),
                              (_ctx.presentFindingTaskObj.auditor != undefined || _ctx.presentFindingTaskObj.auditor != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_215, _toDisplayString(_ctx.getPerson(_ctx.presentFindingTaskObj.auditor)), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_216, "N/A"))
                            ]),
                            _createElementVNode("div", _hoisted_217, [
                              _cache[126] || (_cache[126] = _createElementVNode("label", { class: "controllabel" }, "Auditee", -1)),
                              _cache[127] || (_cache[127] = _createElementVNode("br", null, null, -1)),
                              (_ctx.presentFindingTaskObj.auditee != undefined || _ctx.presentFindingTaskObj.auditee != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_218, _toDisplayString(_ctx.getPersonName(_ctx.presentFindingTaskObj.auditee)), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_219, "N/A"))
                            ]),
                            _createElementVNode("div", _hoisted_220, [
                              _cache[128] || (_cache[128] = _createElementVNode("label", { class: "controllabel" }, "Team", -1)),
                              _cache[129] || (_cache[129] = _createElementVNode("br", null, null, -1)),
                              (_ctx.presentFindingTaskObj.department != undefined || _ctx.presentFindingTaskObj.department != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_221, _toDisplayString(_ctx.getTeamName(_ctx.presentFindingTaskObj.department)), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_222, "N/A"))
                            ]),
                            _createElementVNode("div", _hoisted_223, [
                              _cache[130] || (_cache[130] = _createElementVNode("label", { class: "controllabel" }, "Location", -1)),
                              _cache[131] || (_cache[131] = _createElementVNode("br", null, null, -1)),
                              (_ctx.presentFindingTaskObj.department)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_224, _toDisplayString(_ctx.getLocationName(_ctx.presentFindingTaskObj.department)), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.importpopUp)
            ? (_openBlock(), _createBlock(_component_popup, {
                key: 1,
                popUp: _ctx.importpopUp
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_225, [
                    _createElementVNode("div", _hoisted_226, [
                      _createElementVNode("div", _hoisted_227, [
                        _createElementVNode("div", _hoisted_228, [
                          _createElementVNode("h1", null, _toDisplayString(_ctx.evidenceAttachMode === 'url' ? 'Attach Link' : 'Attach File'), 1),
                          _createElementVNode("button", {
                            class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.onCancelIcon()))
                          }, _cache[133] || (_cache[133] = [
                            _createElementVNode("img", {
                              src: _imports_16,
                              class: "h-5 w-5 cursor-pointer"
                            }, null, -1)
                          ]))
                        ]),
                        _cache[141] || (_cache[141] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                        _createElementVNode("div", _hoisted_229, [
                          _createElementVNode("div", _hoisted_230, [
                            _createElementVNode("div", _hoisted_231, [
                              _createElementVNode("div", _hoisted_232, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("label", _hoisted_233, _toDisplayString(_ctx.evidenceAttachMode === 'url' ? 'Title' : 'File Name'), 1),
                                  _withDirectives(_createElementVNode("input", {
                                    class: _normalizeClass(["inputboxstyling text-xs mt-2", {'is-invalid': _ctx.v$.inputFileName.$error }]),
                                    type: "text",
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.inputFileName) = $event)),
                                    placeholder: _ctx.evidenceAttachMode === 'url' ? 'Evidence title' : 'Filename',
                                    onInput: _cache[30] || (_cache[30] = ($event: any) => (_ctx.v$.inputFileName.$touch()))
                                  }, null, 42, _hoisted_234), [
                                    [
                                      _vModelText,
                                      _ctx.inputFileName,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.inputFileName.$error )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_235, [
                                        (_ctx.v$.inputFileName.required.$invalid )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_236, "Required"))
                                          : ((_ctx.v$.inputFileName.restrictCharacters50 && _ctx.v$.inputFileName.restrictCharacters50.$invalid) || (_ctx.v$.inputFileName.restrictCharacters60 && _ctx.v$.inputFileName.restrictCharacters60.$invalid))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_237, "Charcter Limit is exceeded"))
                                            : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.evidenceAttachMode === 'file')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_238, [
                                      _cache[136] || (_cache[136] = _createElementVNode("label", { class: "controllabel" }, "Attachment", -1)),
                                      _createElementVNode("input", {
                                        type: "file",
                                        ref: "fileInput",
                                        class: "hidden",
                                        id: "upload",
                                        onChange: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                                      }, null, 544),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["w-auto rounded-sm mt-2 p-8 flex flex-col items-center justify-center text-center transition border-2 border-dashed border-lightgrey bg-whitegrey", {
								'is-invalid': _ctx.v$.fileToUpload.$error || _ctx.pdfValidation,
								'border-primary': _ctx.isDragOver
							}]),
                                        onDragenter: _cache[33] || (_cache[33] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent"])),
                                        onDragover: _cache[34] || (_cache[34] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent"])),
                                        onDragleave: _cache[35] || (_cache[35] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args)), ["prevent"])),
                                        onDrop: _cache[36] || (_cache[36] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFileDrop && _ctx.onFileDrop(...args)), ["prevent"]))
                                      }, [
                                        _cache[135] || (_cache[135] = _createElementVNode("img", {
                                          src: _imports_17,
                                          class: "h-10 w-10 mb-3",
                                          alt: "Upload file"
                                        }, null, -1)),
                                        (_ctx.fileName === '')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_239, " Drag and drop your file here "))
                                          : (_openBlock(), _createElementBlock("p", _hoisted_240, _toDisplayString(_ctx.fileName), 1)),
                                        _createElementVNode("div", _hoisted_241, [
                                          _cache[134] || (_cache[134] = _createElementVNode("label", {
                                            for: "upload",
                                            class: "cursor-pointer"
                                          }, [
                                            _createElementVNode("span", { class: "btnprimary text-xs gap-1" }, [
                                              _createElementVNode("img", {
                                                src: _imports_18,
                                                class: "h-4 w-4",
                                                alt: ""
                                              }),
                                              _createTextVNode(" Browse ")
                                            ])
                                          ], -1)),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: _normalizeClass(["filterButton text-xs gap-1", _ctx.fileName === '' ? 'filterButtondisabled pointer-events-none' : '']),
                                            disabled: _ctx.fileName === '',
                                            onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedFile && _ctx.clearSelectedFile(...args)))
                                          }, " Cancel ", 10, _hoisted_242)
                                        ])
                                      ], 34),
                                      _createElementVNode("div", _hoisted_243, [
                                        (_ctx.v$.fileToUpload.$invalid && !_ctx.pdfValidation && (_ctx.v$.fileToUpload.$error || _ctx.pdfValidation))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_244, " File upload is required "))
                                          : _createCommentVNode("", true),
                                        (_ctx.pdfValidation && !_ctx.v$.fileToUpload.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_245, " This File Format is not Supported "))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _cache[137] || (_cache[137] = _createElementVNode("div", { class: "mt-2 flex flex-col items-center" }, [
                                        _createElementVNode("p", { class: "text-xs text-placeholder" }, " Accepted Formats: PDF, JPG, PNG, ZIP, TXT, XLS, DOC, MP4 "),
                                        _createElementVNode("p", { class: "text-xs text-placeholder mt-1" }, " Maximum File Size: 50 MB ")
                                      ], -1))
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.evidenceAttachMode === 'url')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_246, [
                                      _cache[138] || (_cache[138] = _createElementVNode("label", { class: "controllabel" }, "URL", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        class: _normalizeClass(["inputboxstyling text-xs mt-2", {'is-invalid': _ctx.v$.evidenceUrl.$error }]),
                                        type: "url",
                                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.evidenceUrl) = $event)),
                                        placeholder: "URL",
                                        onInput: _cache[38] || (_cache[38] = ($event: any) => (_ctx.v$.evidenceUrl.$touch()))
                                      }, null, 34), [
                                        [
                                          _vModelText,
                                          _ctx.evidenceUrl,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ]),
                                      (_ctx.v$.evidenceUrl.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_247, [
                                            (_ctx.v$.evidenceUrl.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_248, "Required"))
                                              : (_ctx.v$.evidenceUrl.httpUrl.$invalid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_249, "URL must use http or https"))
                                                : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_250, [
                                  _cache[139] || (_cache[139] = _createElementVNode("label", { class: "controllabel" }, "Evidence Date", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.evidenceDate) = $event)),
                                    type: "date",
                                    class: _normalizeClass(["mt-2 w-full", {
									'inputboxstylingForSelectAtPopup': _ctx.evidenceDate == '',
									'stylingForInputboxstylingForSelectAtPopup': _ctx.evidenceDate != '',
									'is-invalid':_ctx.v$.evidenceDate.$error
									}]),
                                    onFocus: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                                    style: {"height":"28px"},
                                    onkeydown: "return false",
                                    placeholder: "Select Date",
                                    max: _ctx.todayDate
                                  }, null, 42, _hoisted_251), [
                                    [_vModelText, _ctx.evidenceDate]
                                  ]),
                                  (_ctx.v$.evidenceDate.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                                        (_ctx.v$.evidenceDate.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_253, "Evidence date is required"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[140] || (_cache[140] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                          _createElementVNode("div", _hoisted_254, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["btnprimary", _ctx.isEvidenceSaveDisabled ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                              onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
                              disabled: _ctx.clickOnButton
                            }, "Save", 10, _hoisted_255)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["popUp"]))
            : _createCommentVNode("", true),
          (_ctx.showApprovalPopup)
            ? (_openBlock(), _createBlock(_component_popup, {
                key: 2,
                popUp: _ctx.showApprovalPopup
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_256, [
                    _createElementVNode("div", _hoisted_257, [
                      _createElementVNode("div", _hoisted_258, [
                        _createElementVNode("div", _hoisted_259, [
                          _cache[143] || (_cache[143] = _createElementVNode("h1", null, "Approval", -1)),
                          _createElementVNode("button", {
                            class: "float-right text-3xl",
                            onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.onCrossbtn()))
                          }, _cache[142] || (_cache[142] = [
                            _createElementVNode("img", {
                              src: _imports_16,
                              class: "cursor-pointer"
                            }, null, -1)
                          ]))
                        ]),
                        _cache[147] || (_cache[147] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                        _createElementVNode("div", _hoisted_260, [
                          _createElementVNode("div", _hoisted_261, [
                            _createElementVNode("div", _hoisted_262, [
                              _createElementVNode("div", _hoisted_263, [
                                _createElementVNode("div", _hoisted_264, [
                                  _createElementVNode("div", _hoisted_265, [
                                    _cache[144] || (_cache[144] = _createElementVNode("label", { class: "controllabel" }, "Name of the Authority", -1)),
                                    _createVNode(_component_AutoComplete, {
                                      appendTo: "body",
                                      modelValue: _ctx.approvalSent,
                                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.approvalSent) = $event)),
                                      suggestions: _ctx.userOptions,
                                      placeholder: "Assigned-To",
                                      optionLabel: "label",
                                      field: "label",
                                      class: _normalizeClass(["w-full custom-autocomplete userSelect mt-2", {
												'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
												'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== '',
											}]),
                                      onComplete: _ctx.asyncFindApprovals
                                    }, null, 8, ["modelValue", "suggestions", "onComplete", "class"])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_266, [
                                _createElementVNode("div", _hoisted_267, [
                                  _cache[145] || (_cache[145] = _createElementVNode("label", { class: "controllabel" }, "Justification or Comments for Approving", -1)),
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: "inputboxstyling mt-2",
                                    placeholder: "Comments",
                                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.taskObj.approvalComments) = $event))
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      _ctx.taskObj.approvalComments,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[146] || (_cache[146] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                            _createElementVNode("div", _hoisted_268, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["btnprimary mr-2", (_ctx.taskObj.approvalComments=='')?'btndisabled pointer-events-none':'btnprimary']),
                                onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.onCancelbtnAtApproval()))
                              }, "Cancel", 2),
                              _createElementVNode("button", {
                                class: _normalizeClass(["btnprimary", (_ctx.taskObj.approvalComments=='')?'btndisabled pointer-events-none':'btnprimary']),
                                disabled: _ctx.clickOnButtonForApproval,
                                onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.clickOnSaveForApproval()))
                              }, "Save", 10, _hoisted_269)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["popUp"]))
            : _createCommentVNode("", true),
          (_ctx.showRejectPopupForNormalApproval)
            ? (_openBlock(), _createBlock(_component_popup, {
                key: 3,
                popUp: _ctx.showRejectPopupForNormalApproval
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_270, [
                    _cache[149] || (_cache[149] = _createElementVNode("h1", null, "Justification to Reject an Approval", -1)),
                    _createElementVNode("button", {
                      class: "float-right text-3xl",
                      onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.onCrossBtnForNormalApproval()))
                    }, _cache[148] || (_cache[148] = [
                      _createElementVNode("img", {
                        src: _imports_16,
                        class: "cursor-pointer"
                      }, null, -1)
                    ]))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_271, [
                    _createElementVNode("div", _hoisted_272, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_273, [
                          _createElementVNode("div", _hoisted_274, [
                            _cache[150] || (_cache[150] = _createElementVNode("label", { class: "controllabel" }, "Justification or Comments for Rejecting", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              class: "inputboxstyling mt-2",
                              placeholder: "Comments",
                              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.normalJustification.justification) = $event))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.normalJustification.justification,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[151] || (_cache[151] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                      _createElementVNode("div", _hoisted_275, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary mr-2", 
							_ctx.normalJustification.justification == ''
							? 'btndisabled pointer-events-none'
							: 'btnprimary'
						]),
                          onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.onCancelbtnForNormalApproval()))
                        }, " Cancel ", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary", 
							_ctx.normalJustification.justification == ''
							? 'btndisabled pointer-events-none'
							: 'btnprimary'
						]),
                          onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.approveOrRejectForActionTasktoComplete(10401,7))),
                          disabled: _ctx.clickOnButtonForApproveOrReject
                        }, " Save ", 10, _hoisted_276)
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["popUp"]))
            : _createCommentVNode("", true),
          (_ctx.showRejectPopupAtInReview)
            ? (_openBlock(), _createBlock(_component_popup, {
                key: 4,
                popUp: _ctx.showRejectPopupAtInReview
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_277, [
                    _cache[153] || (_cache[153] = _createElementVNode("h1", null, "Justification to Reject an Approval", -1)),
                    _createElementVNode("button", {
                      class: "float-right text-3xl",
                      onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.onCrossBtnForFinalApproval()))
                    }, _cache[152] || (_cache[152] = [
                      _createElementVNode("img", {
                        src: _imports_16,
                        class: "cursor-pointer"
                      }, null, -1)
                    ]))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_278, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_279, [
                          _createElementVNode("div", _hoisted_280, [
                            _cache[154] || (_cache[154] = _createElementVNode("label", { class: "controllabel" }, "Justification or Comments for Rejecting", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              class: "inputboxstyling mt-2",
                              placeholder: "Comments",
                              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.finalJustification.justification) = $event))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.finalJustification.justification,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_281, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary mr-2", 
						_ctx.finalJustification.justification == ''
						? 'btndisabled pointer-events-none'
						: 'btnprimary'
					]),
                          onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.onCancelbtnForFinalApproval()))
                        }, " Cancel ", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary", 
						_ctx.finalJustification.justification == ''
						? 'btndisabled pointer-events-none'
						: 'btnprimary'
					]),
                          onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.ApprovalforInprogress(10410))),
                          disabled: _ctx.clickOnButtonForInProgress
                        }, " Save ", 10, _hoisted_282)
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["popUp"]))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.showDeleteEvidenceConfirm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_283, [
              _createElementVNode("div", {
                class: "evidence-delete-backdrop",
                onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteEvidence && _ctx.cancelDeleteEvidence(...args)))
              }),
              _createElementVNode("div", _hoisted_284, [
                _cache[155] || (_cache[155] = _createElementVNode("div", { class: "evidence-delete-dialog-title" }, [
                  _createElementVNode("div", { class: "evidence-delete-warning" }, [
                    _createElementVNode("img", {
                      src: _imports_19,
                      class: "evidence-delete-warning-icon",
                      alt: ""
                    })
                  ]),
                  _createElementVNode("span", null, "Delete Evidence")
                ], -1)),
                _cache[156] || (_cache[156] = _createElementVNode("p", { class: "evidence-delete-dialog-message" }, "Are you sure you want to delete this evidence?", -1)),
                _createElementVNode("div", _hoisted_285, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "evidence-delete-cancel",
                    onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteEvidence && _ctx.cancelDeleteEvidence(...args)))
                  }, "Cancel"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "evidence-delete-ok",
                    onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteEvidence && _ctx.confirmDeleteEvidence(...args)))
                  }, "OK")
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.linkEvidencePopup)
          ? (_openBlock(), _createElementBlock("div", _hoisted_286, [
              _createElementVNode("div", {
                class: "link-existing-backdrop",
                onClick: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.closeLinkEvidencePopup && _ctx.closeLinkEvidencePopup(...args)))
              }),
              _createElementVNode("div", _hoisted_287, [
                _cache[166] || (_cache[166] = _createElementVNode("div", { class: "link-existing-title" }, [
                  _createElementVNode("span", {
                    class: "link-existing-warning",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("img", {
                      src: _imports_19,
                      class: "link-existing-warning-icon",
                      alt: ""
                    })
                  ]),
                  _createElementVNode("span", null, "Link Existing Evidence")
                ], -1)),
                _cache[167] || (_cache[167] = _createElementVNode("p", { class: "link-existing-message" }, "Select evidence from the past year listed below.", -1)),
                _createElementVNode("div", _hoisted_288, [
                  _createElementVNode("div", _hoisted_289, [
                    _createElementVNode("div", _hoisted_290, "EXISTING EVIDENCE (" + _toDisplayString(_ctx.filteredSortedExistingEvidences.length) + ")", 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "filterButton flex",
                      onClick: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_ctx.toggleExistingEvidenceFilters && _ctx.toggleExistingEvidenceFilters(...args)))
                    }, _cache[157] || (_cache[157] = [
                      _createElementVNode("img", {
                        src: _imports_20,
                        class: "filterIcon"
                      }, null, -1),
                      _createTextVNode(" Filters ")
                    ]))
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["link-existing-table-wrap", { 'link-existing-table-wrap--empty': _ctx.filteredSortedExistingEvidences.length === 0 }])
                  }, [
                    _createElementVNode("table", _hoisted_291, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _cache[162] || (_cache[162] = _createElementVNode("th", { class: "link-existing-col-check" }, null, -1)),
                          _createElementVNode("th", {
                            class: "cursor-pointer",
                            onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.sortExistingEvidence('filename')))
                          }, [
                            _createElementVNode("div", _hoisted_292, [
                              _cache[158] || (_cache[158] = _createElementVNode("div", { class: "table-header-label" }, "TITLE", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'filename' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", {
                            class: "cursor-pointer",
                            onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.sortExistingEvidence('sourceTaskId')))
                          }, [
                            _createElementVNode("div", _hoisted_293, [
                              _cache[159] || (_cache[159] = _createElementVNode("div", { class: "table-header-label" }, "TASK ID", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'sourceTaskId' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", {
                            class: "cursor-pointer",
                            onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.sortExistingEvidence('evidenceType')))
                          }, [
                            _createElementVNode("div", _hoisted_294, [
                              _cache[160] || (_cache[160] = _createElementVNode("div", { class: "table-header-label" }, "TYPE", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'evidenceType' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", {
                            class: "cursor-pointer",
                            onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.sortExistingEvidence('evidenceDate')))
                          }, [
                            _createElementVNode("div", _hoisted_295, [
                              _cache[161] || (_cache[161] = _createElementVNode("div", { class: "table-header-label" }, "EVIDENCE DATE", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'evidenceDate' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                              }, null, 2)
                            ])
                          ])
                        ]),
                        (_ctx.showExistingEvidenceFilters)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_296, [
                              _cache[163] || (_cache[163] = _createElementVNode("td", { class: "link-existing-col-check" }, null, -1)),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "searchForInputBoxStyling",
                                  "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.existingEvidenceFilters.filename) = $event)),
                                  placeholder: "Search",
                                  onClick: _cache[65] || (_cache[65] = _withModifiers(() => {}, ["stop"]))
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    _ctx.existingEvidenceFilters.filename,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "searchForInputBoxStyling",
                                  "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.existingEvidenceFilters.sourceTaskId) = $event)),
                                  placeholder: "Search",
                                  onClick: _cache[67] || (_cache[67] = _withModifiers(() => {}, ["stop"]))
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    _ctx.existingEvidenceFilters.sourceTaskId,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "searchForInputBoxStyling",
                                  "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.existingEvidenceFilters.evidenceType) = $event)),
                                  placeholder: "Search",
                                  onClick: _cache[69] || (_cache[69] = _withModifiers(() => {}, ["stop"]))
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    _ctx.existingEvidenceFilters.evidenceType,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              ]),
                              _cache[164] || (_cache[164] = _createElementVNode("td", null, null, -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.filteredSortedExistingEvidences.length)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_297, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSortedExistingEvidences, (row) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: row.optionKey
                              }, [
                                _createElementVNode("td", _hoisted_298, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: _ctx.isExistingEvidenceSelected(row),
                                    onChange: ($event: any) => (_ctx.toggleExistingEvidence(row))
                                  }, null, 40, _hoisted_299)
                                ]),
                                _createElementVNode("td", {
                                  title: row.filename
                                }, _toDisplayString(row.filename), 9, _hoisted_300),
                                _createElementVNode("td", null, _toDisplayString(row.sourceTaskId), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.existingEvidenceTypeLabel(row)), 1),
                                _createElementVNode("td", null, _toDisplayString(row.evidenceDate ? _ctx.formatFileAttachedTime(row.evidenceDate) : 'N/A'), 1)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_301, _cache[165] || (_cache[165] = [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", {
                                class: "link-existing-empty",
                                colspan: "5"
                              }, "No Records Found")
                            ], -1)
                          ])))
                    ])
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_302, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "link-existing-cancel",
                    onClick: _cache[70] || (_cache[70] = 
//@ts-ignore
(...args) => (_ctx.closeLinkEvidencePopup && _ctx.closeLinkEvidencePopup(...args)))
                  }, "Cancel"),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["link-existing-save", _ctx.selectedExistingEvidences.length === 0 ? 'link-existing-save-disabled' : '']),
                    onClick: _cache[71] || (_cache[71] = 
//@ts-ignore
(...args) => (_ctx.saveLinkedEvidence && _ctx.saveLinkedEvidence(...args)))
                  }, "Save", 2)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}